export enum Error {
  none = '',
  unableToLoad = 'Unable to load todos',
  titleShouldNotBeEmpty = 'Title should not be empty',
  unableToAdd = 'Unable to add a todo',
  unableToDelete = 'Unable to delete a todo',
  unableToUpdate = 'Unable to update a todo',
}
